module.exports = __webpack_public_path__ + "static/img/autogood3.f53c07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood3.png
// module id = ODev
// module chunks = 1